module.exports = __webpack_public_path__ + "static/img/838b4325c8a132ff6bb0.4312ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/838b4325c8a132ff6bb0.jpg
// module id = RrBs
// module chunks = 1